/* eslint-disable arrow-body-style */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { getLocale, useDispatch, useIntl } from 'umi';
import moment from 'moment';
import DateSelect from '@op/components/FilterCommon/widgets/DateSelect';
import { getOpinionFilterCond } from '@op/services/filter';
import useTranslateTopic from '@op/hooks/useTranslateTopic';
import { LANGUAGE_EN } from '@home/_config/config';
import { ConfigProvider } from 'tea-component';
import componentMap from '@/pages/dashboard/_config/compConfig';
import { addStudioChannel } from '../StudioTrendingVideo/utils';
import { addSplitText, getAccountListValue, studioAccountsPageOfficialAccounts } from '@op/components/FilterCommon/utils/monitorUtil';
import { getByChannelAccountCount } from '@op/services';

interface IProps {
  children?: React.ReactNode;
  gameInfo: any;
  wholeGameInfo: any;
  config?: {
    needFilterCond?: boolean;
    needChannelLst?: boolean;
    dateTypeList?: string[];
    extraParams?: any;
    leftSlot?: {
      name: string;
      props?: any;
    };
    needPriveiw?: boolean;
    filterAccount?: string[];
  };
}

export default function OpinionsFilter(props: IProps) {
  const { gameInfo, wholeGameInfo, children, config } = props;
  const { needFilterCond = true, needChannelLst = false, dateTypeList = ['date', 'hour', 'week', 'month'], leftSlot, extraParams, needPriveiw, filterAccount } = config || {};
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const defaultStartTime = moment().subtract(6, 'days').format('YYYY-MM-DD 00:00:00');
  const defaultEndTime = moment().format('YYYY-MM-DD 23:59:59');
  const [timeValue, setTimeValue] = useState({});
  const [isConfirm, setIsConfirm] = useState(false);
  const [isInit, setIsInit] = useState(true);
  const [filterCond, setFilterCond] = useState<any>(null);
  const [filterLoading, setFilterLoading] = useState(true);
  const [channelList, setChannelList] = useState<any>([]);
  const { setTranslateTopicMap, translateTopicFunc, translateTopic: translateTopicMap } = useTranslateTopic(getLocale());

  const dispatch = useDispatch();

  const filter = useMemo(() => ({
    ...gameInfo,
    ...timeValue,
    isConfirm
  }), [gameInfo, timeValue]);

  const memoizedFilterAccount = useMemo(() => filterAccount, [filterAccount]);

  // 请求筛选器数据用于Trending Publications参数处理
  useEffect(() => {
    if (!gameInfo || !needFilterCond) return;
    const { edition_unified_id, entity_type, id_type } = gameInfo || {};
    const params = {
      edition_unified_id,
      entity_type,
      id_type,
      request_type: ["channel", "monitor_by_account_category", 'topic'],
      un_request_type: ["topic_trans"],
      ...extraParams,
    };
    setFilterLoading(true);
    getOpinionFilterCond(params).then((res: any) => {
      // 获取account和channel参数
      const monitory = res?.monitor_by_account_category?.monitory;
      const accountData = studioAccountsPageOfficialAccounts(monitory);
      const accounts: string[] = [];
      // 循环遍历出所有account
      Object.keys(accountData)?.forEach(key => {
        accountData[key]?.forEach((item: { account: string; }) => {
          accounts?.push(item?.account);
        });
      });

      // 获取filter后monitor_by_account_category参数
      let socialMediaByAccount = undefined;
      if(Array.isArray(memoizedFilterAccount) && memoizedFilterAccount.length > 0){
        const newAccount: any = {};
        Object.keys(monitory).forEach((key) => {
          if (monitory[key]) {
            newAccount[key] = monitory[key]?.filter((item: any) => !memoizedFilterAccount?.includes(item?.account?.toLocaleLowerCase?.()));
          }
        });
        socialMediaByAccount = getAccountListValue(newAccount);
      }
      
      setFilterCond({ ...res, accounts, social_media_by_account: socialMediaByAccount });
      setTranslateTopicMap(res?.topic_trans);
      setFilterLoading(false);
      if (needChannelLst) {
        const channels = addStudioChannel(res?.channel?.social || []);
        getByChannelAccountCount({
          edition_unified_id,
          entity_type,
          id_type,
          channels,
          accounts
        }).then((res2: any) => {
          const data = res2?.map((info: any) => {
            return {
              ...info,
              List: info?.List.map((item: string) => addSplitText(item, info?.channel))
            };
          });
          setChannelList(data);
        }).catch((err: any) => {
          console.log(err);
          setChannelList([]);
        });
      }
    }).catch((err: any) => {
      console.log(err);
      setFilterCond({});
      setFilterLoading(false);
    });
  }, [gameInfo, needFilterCond, extraParams, memoizedFilterAccount]);


  const renderLeftSlot = useCallback(() => {
    if (!leftSlot) return null;
    const { name, ...resetProps } = leftSlot || {};
    const LeftSlotCom = componentMap?.[name];

    return LeftSlotCom ? <LeftSlotCom filter={filter} channelList={channelList}
      {...(resetProps || {})}
    /> : null;
  }, [leftSlot, channelList]);

  return (
    <ConfigProvider locale={isEn ? 'zh' : "en"}>
      <div className="dbh-studio-opinions-v2">
        {
          leftSlot && renderLeftSlot()
        }

        <div className="dbh-studio-operate">
          <div className="search-item search-item-date">
            <DateSelect
              lang={getLocale()}
              dateTypeList={dateTypeList}
              gameInfo={gameInfo}
              useNewsTypes={false}
              filterOptions={{ time: filterCond?.time }}
              defaultValue={{
                start_time: defaultStartTime,
                end_time: defaultEndTime,
              }}
              onChange={(timeKey: any, result: any) => {
                if (result?.value?.start_time && result?.value?.end_time) {
                  if (needPriveiw) {
                    // 先清空缓存数据
                    dispatch({ type: 'studioAutoReport/clearAllCacheData' });
                  };
                  setTimeValue(result?.value);
                  !isInit && setIsConfirm(true);
                  setIsInit(false);
                }
              }}
            />
          </div>
        </div>
        {
          children && React.Children.map(children, child => React.cloneElement(child, {
            gameInfo,
            filter,
            filterCond,
            filterLoading,
            wholeGameInfo,
            timeValue,
            channelList,
            // isDelay: true,
            // // 当前只有StudioTrendingVideo组件有这个传参
            // language: 'origin',
            translateTopic: translateTopicFunc,
            translateTopicMap,
          }))
        }
      </div>
    </ConfigProvider>

  );
}
